/** Canonical lifecycle states persisted on Service Plan status records. */
export enum ServicePlanStatusSystemName {
    Draft = 'Draft',
    Started = 'Started',
    Paused = 'Paused',
    Archived = 'Archived',
}
